module.exports = __webpack_public_path__ + "img/clients_title.8127143e.svg";